import { render, staticRenderFns } from "./peopleTable.vue?vue&type=template&id=4549f6ae&scoped=true"
import script from "./peopleTable.vue?vue&type=script&lang=js"
export * from "./peopleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4549f6ae",
  null
  
)

export default component.exports